// ============================================================================
// FNE-BRIDGE Frontend - Hook notifications (snackbar)
// ============================================================================

import { create } from 'zustand';

type Severity = 'success' | 'error' | 'warning' | 'info';

interface SnackbarState {
  open: boolean;
  message: string;
  severity: Severity;
  duration: number;
  show: (message: string, severity?: Severity, duration?: number) => void;
  success: (message: string) => void;
  error: (message: string) => void;
  warning: (message: string) => void;
  info: (message: string) => void;
  close: () => void;
}

export const useNotification = create<SnackbarState>((set) => ({
  open: false,
  message: '',
  severity: 'info',
  duration: 4000,

  show: (message, severity = 'info', duration = 4000) =>
    set({ open: true, message, severity, duration }),

  success: (message) =>
    set({ open: true, message, severity: 'success', duration: 4000 }),

  error: (message) =>
    set({ open: true, message, severity: 'error', duration: 6000 }),

  warning: (message) =>
    set({ open: true, message, severity: 'warning', duration: 5000 }),

  info: (message) =>
    set({ open: true, message, severity: 'info', duration: 4000 }),

  close: () => set({ open: false }),
}));
